import type { FC } from "react";
import type { SalesAssessmentRankingResults } from "./mocks";
import { Presentation } from "./Presentation";
import { useConvertedResults } from "./useConvertedResults";
import { useRecommendWorks } from "./useRecommendWorks";

type Props = {
  jobTypeName: string;
  location: string;
  title: string;
  salesAssessmentRankingResults: SalesAssessmentRankingResults;
  shareUrl: string;
  appPromotionPath: string;
  recommendWorksFetchUrl: string;
  showCampaignBanner: boolean;
};

export const AssessmentResult: FC<Props> = ({
  jobTypeName,
  location,
  title,
  salesAssessmentRankingResults,
  shareUrl,
  appPromotionPath,
  recommendWorksFetchUrl,
  showCampaignBanner,
}) => {
  const { genreResults, graphCassetteProps } = useConvertedResults(
    salesAssessmentRankingResults,
    jobTypeName,
  );
  const { recommendWorks, isLoading, error } = useRecommendWorks(recommendWorksFetchUrl);

  const filteredRecommendWorks = recommendWorks.filter(
    (recommendWork) => recommendWork.works.length > 0,
  );
  const hasRecommendWorks = !isLoading && !error && filteredRecommendWorks.length > 0;

  return (
    <Presentation
      businessTypeName={jobTypeName}
      location={location}
      title={title}
      genreResults={genreResults}
      graphCassetteProps={graphCassetteProps}
      shareUrl={shareUrl}
      appPromotionPath={appPromotionPath}
      recommendWorks={filteredRecommendWorks}
      hasRecommendWorks={hasRecommendWorks}
      showCampaignBanner={showCampaignBanner}
    />
  );
};
